import { RefObject } from 'react';

export function isRefPresent<T>(ref: RefObject<T | null>): ref is RefObject<T> {
   return ref.current !== null;
}
